export type ServerMonth = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type TsMonth = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export const MonthAdapter = {
    adapt: (m: ServerMonth) => m - 1 as TsMonth,
    toApi: (m: TsMonth) => m + 1 as ServerMonth
}

export const formatMonth = (month: number, option: 'short' | 'long' | '2-digit' | 'numeric' | 'narrow') => {
    const d = new Date('01-01-2001');
    d.setMonth(month);
    return d.toLocaleDateString(undefined, { month: option });
}

export interface AbsoluteMonth {
    id: number;
    name: string;
    year: number;
    month: number;
    label: string;
}

export function constructAbsoluteMonths(current: Date, endMonth: number, numOfMonth: number = 12): AbsoluteMonth[] {
    const currentYear = current.getFullYear();
    const currentMonth = current.getMonth();
    const endYear = currentMonth > endMonth ? currentYear + 1 : currentYear;
    const endEpoch = (endYear * 12) + endMonth;
    const start = endEpoch - 11;
    return Array.from({ length: numOfMonth }, (_, i) => {
        const id = start + i;
        const year = Math.floor(id / 12);
        const month = id % 12;
        return { id, name: String(id), year, month, label: `${formatMonth(month, 'short')} ${String(year).slice(-2)}` };
    })
}

export function isWithinAbsoluteMonthRange(targetAbsMonth: number, startDate: Date, endDate: Date) {
    const start = toAbsoluteMonth(startDate);
    const end = toAbsoluteMonth(endDate);
    return targetAbsMonth > start && targetAbsMonth <= end;
}

export function toAbsoluteMonth(year: number, month: number): number;
export function toAbsoluteMonth(date: Date): number;
export function toAbsoluteMonth(param1: Date | number, param2?: number): number {
    if (param1 instanceof Date) {
        return (param1.getFullYear() * 12) + param1.getMonth();
    }
    return (param1 * 12) + param2;
}

export function fromAbsoluteMonth(absMonth: number): { year: number; month: number; } {
    const year = Math.floor(absMonth / 12);
    const month = absMonth % 12;
    return { year, month };
}
